/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scene_Outside_ShipmentInputs */

const en_scene_outside_shipment = /** @type {(inputs: Scene_Outside_ShipmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shipment`)
};

/**
* | output |
* | --- |
* | "Shipment" |
*
* @param {Scene_Outside_ShipmentInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const scene_outside_shipment = /** @type {((inputs?: Scene_Outside_ShipmentInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scene_Outside_ShipmentInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_scene_outside_shipment(inputs)
});